import { jsx as _jsx } from "react/jsx-runtime";
import { SelectionList, Text, } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { categoryTitles } from 'components/categorizedList/utils/categories';
/** Represents a categories menu. */
export const CategorizedListMenu = ({ categories, visibleCategoryIds, onChange, }) => {
    /**
     * The single first visible menu category that goes into the selection list.
     * This has to be an array as this is what the list expects.
     */
    const menuCategory = useMemo(() => {
        const firstVisibleCategory = categories.find((category) => visibleCategoryIds.some((id) => id === category.id));
        return firstVisibleCategory ? [firstVisibleCategory] : [];
    }, [categories, visibleCategoryIds]);
    return (_jsx(SelectionList, Object.assign({ selectedValues: menuCategory, onChange: onChange, equalityFn: (a, b) => a.id === b.id }, { children: categories.map((category) => (_jsx(SelectionList.Item, Object.assign({ value: category }, { children: _jsx(Text.Paragraph, Object.assign({ variant: "3" }, { children: categoryTitles[category.id] })) }), category.id))) })));
};
